// ── SCHOOL AUTOCOMPLETE ──────────────────────────────────────────────────────────
// Native <datalist> doesn't filter by typed text in Safari (shows the whole list),
// so we drive a small custom dropdown instead. Delegated on document so it works
// against inputs that get re-rendered into modals via innerHTML.
import { SCHOOLS } from './state.js';

let acEl = null, acInput = null, acItems = [], acActive = -1;
function acClose() { if (acEl) { acEl.remove(); acEl = null; } acInput = null; acItems = []; acActive = -1; }
function acPosition() {
  const r = acInput.getBoundingClientRect();
  acEl.style.left = r.left + 'px';
  acEl.style.top = (r.bottom + 4) + 'px';
  acEl.style.width = r.width + 'px';
}
function acRender() {
  acEl.innerHTML = acItems.map((s, i) => `<div class="ac-item${i === acActive ? ' hi' : ''}" data-i="${i}">${esc(s)}</div>`).join('');
}
function acMatches(q) {
  const starts = [], contains = [];
  for (const s of SCHOOLS) {
    const low = s.toLowerCase();
    if (low.startsWith(q)) starts.push(s);
    else if (low.includes(q)) contains.push(s);
  }
  return starts.concat(contains).slice(0, 8);
}
function acSelect(i) {
  if (!acInput || !acItems[i]) return;
  acInput.value = acItems[i];
  acInput.dispatchEvent(new Event('input', { bubbles: true }));
  acClose();
}
document.addEventListener('input', e => {
  const input = e.target.closest('[data-school-input]');
  if (!input) return;
  const q = input.value.trim().toLowerCase();
  if (!q) { acClose(); return; }
  const matches = acMatches(q);
  if (!matches.length) { acClose(); return; }
  acInput = input;
  acItems = matches;
  acActive = -1;
  if (!acEl) {
    acEl = document.createElement('div');
    acEl.className = 'ac-list';
    document.body.appendChild(acEl);
    acEl.addEventListener('mousedown', ev => {
      const item = ev.target.closest('.ac-item');
      if (!item) return;
      ev.preventDefault();
      acSelect(parseInt(item.dataset.i, 10));
    });
  }
  acPosition();
  acRender();
});
document.addEventListener('keydown', e => {
  if (!acEl || e.target !== acInput) return;
  if (e.key === 'ArrowDown') { e.preventDefault(); acActive = Math.min(acActive + 1, acItems.length - 1); acRender(); }
  else if (e.key === 'ArrowUp') { e.preventDefault(); acActive = Math.max(acActive - 1, 0); acRender(); }
  else if (e.key === 'Enter' && acActive >= 0) { e.preventDefault(); acSelect(acActive); }
  else if (e.key === 'Escape') { acClose(); }
});
document.addEventListener('focusout', e => { if (e.target === acInput) setTimeout(() => { if (document.activeElement !== acInput) acClose(); }, 0); });
window.addEventListener('scroll', () => { if (acEl) acPosition(); }, true);
window.addEventListener('resize', () => acClose());
